import { NavLink, Navigate, Route, Routes } from 'react-router-dom';
import { fehlendeFunktion, upgradeAnbieten } from '../../billtoro/upgrade';
import { TarifMarke } from '../tarifHinweis';
import type { Overview } from '../types';
import { Ausgaben } from './Ausgaben';
import { Euer } from './Euer';
import { Kassenbuch } from './Kassenbuch';
import { SteuerEinstellungen } from './SteuerEinstellungen';
import { Ustva, UstvaZeitraum } from './Ustva';
import './ausgaben.css';

// „Ausgaben & Steuer“ (/rechnung/steuer, Billtoro Paket 2): Ausgaben mit Beleg, Kassenbuch, Umsatzsteuer-Voranmeldung,
// Einnahmen-Überschuss-Rechnung und die Einstellungen dazu. Im Tarif ohne die Funktion lässt sich alles ansehen; Knöpfe
// zum Erfassen tragen die Marke des Tarifs und öffnen „Mehr mit Billtoro“.
export function Steuer({ data }: { data: Overview }) {
  const fehltAusgaben = fehlendeFunktion(data.tarif, 'ausgaben');
  const fehltUstva = fehlendeFunktion(data.tarif, 'ustva');
  const p = { data, fehltAusgaben, fehltUstva };
  return (
    <>
      <nav className="ag-nav rt-chips" aria-label="Ausgaben und Steuer">
        <NavLink to="/rechnung/steuer" end className="rt-chip">
          Ausgaben
        </NavLink>
        <NavLink to="/rechnung/steuer/kasse" className="rt-chip">
          Kassenbuch
        </NavLink>
        <NavLink to="/rechnung/steuer/ustva" className="rt-chip">
          Umsatzsteuer
        </NavLink>
        <NavLink to="/rechnung/steuer/euer" className="rt-chip">
          Gewinn (EÜR)
        </NavLink>
        <NavLink to="/rechnung/steuer/einstellungen" className="rt-chip">
          Einstellungen
        </NavLink>
      </nav>
      {fehltAusgaben && (
        <div className="ag-sperre">
          <span>
            Ausgaben, Kassenbuch, EÜR und Umsatzsteuer gibt es im Tarif <TarifMarke tarif={data.tarif} fehlt={fehltAusgaben} />.
            Vorhandene Ausgaben, das Kassenbuch und die Voranmeldungen können Sie immer ansehen und herunterladen.
          </span>
          {fehltAusgaben !== 'bald' && (
            <button type="button" className="btn small primary" onClick={() => upgradeAnbieten(data.tarif, 'ausgaben')}>
              Tarif ansehen
            </button>
          )}
        </div>
      )}
      <Routes>
        <Route index element={<Ausgaben {...p} />} />
        <Route path="kasse" element={<Kassenbuch {...p} />} />
        <Route path="ustva" element={<Ustva {...p} />} />
        <Route path="ustva/:jahr/:zeitraum" element={<UstvaZeitraum {...p} />} />
        <Route path="euer" element={<Euer {...p} />} />
        <Route path="einstellungen" element={<SteuerEinstellungen {...p} />} />
        <Route path="*" element={<Navigate to="/rechnung/steuer" replace />} />
      </Routes>
    </>
  );
}

export type Fehlt = ReturnType<typeof fehlendeFunktion>;
export interface SeitenProps {
  data: Overview;
  fehltAusgaben: Fehlt;
  fehltUstva: Fehlt;
}

// Jahr wählen (dieses und die 5 davor)
export function JahrWahl({ jahr, heute, onChange }: { jahr: number; heute: string; onChange(j: number): void }) {
  const aktuell = Number(heute.slice(0, 4));
  const jahre = Array.from({ length: 6 }, (_, i) => aktuell - i);
  return (
    <select className="ag-jahr" value={jahr} aria-label="Jahr" onChange={(e) => onChange(Number(e.target.value))}>
      {jahre.map((j) => (
        <option key={j} value={j}>
          {j}
        </option>
      ))}
    </select>
  );
}
